function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#331C10",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M14.99 15.326V20H8.687l-4.674-4.674h10.975zM20 9.053v6.26l-4.66 4.659V15.13h-.014V9.053H20zM8.716 4v10.99H4V8.687L8.688 4h.028zm6.596 0L20 8.688v.028H9.053V4h6.26z"
}));

var SvgIcJpm = function SvgIcJpm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcJpm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_jpm.92953be8.svg";
export { ForwardRef as ReactComponent };